export default __webpack_public_path__ + "static/media/gallery-wip-blade plug pin_01.dbca1427.jpg";